/* eslint-disable no-undef */
export default {
	name: "select-order-type-modal",
	props: ["heading", "modalId", "showModal", "canViewCollectionOrders", "canViewDeliveryOrders", "currentOrderTypeId"],
	emits: ["placeOrder", "onCancelClicked"],
	data() {
		return {
			orderTypeId: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			orderTypes: [],
			collectionId: 2,
			customer: {
				value: null,
				hasError: false,
				errorMessage: null
			},
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			clearCustomerSearch: false
		};
	},
	methods: {
		getOrderTypes(){
			console.log("canViewCollectionOrders", this.canViewCollectionOrders);
			this.orderTypes = orderService.getOrderTypes();
			this.orderTypeId.value = this.orderTypes[0].orderTypeId;
			this.collectionId = orderHelper.orderType.collection;
			for(let i = 0; i < this.orderTypes.length; i++){
				this.orderTypes[i].canPlaceOrderForThisOrderType = true;
				if(this.orderTypes[i].orderTypeId === orderHelper.orderType.collection && !this.canViewCollectionOrders){
					this.orderTypes[i].canPlaceOrderForThisOrderType = false;
				}
				if(this.orderTypes[i].orderTypeId === orderHelper.orderType.delivery && !this.canViewDeliveryOrders){
					this.orderTypes[i].canPlaceOrderForThisOrderType = false;
				}
			}
			console.log("orderTypes", this.orderTypes);
		},
		onCustomerSelected(customer){
			this.customer.value = customer;
			this.onPlaceOrderClick();
		},
		onModalCloseClick(){
			console.log("onCancelClicked");
			this.clearCustomerSearch = true;
			this.$emit("onCancelClicked", true);
		},
		onPlaceOrderClick(){
			let error = false;
			if(this.customer.value === null || this.customer.value <= 0){
				this.customer.hasError = true;
				this.customer.errorMessage = "Please select a customer to place an order for";
				error = true;
			}
			// if(this.orderTypeId.value === null || this.orderTypeId.value <= 0){
			// 	this.orderTypeId.hasError = true;
			// 	this.orderTypeId.errorMessage = "Please select an order type to place an order for";
			// 	error = true;
			// }
			if(!error){
				let orderToPlace = {
					company: this.customer.value,
					orderTypeId: this.orderTypeId.value
				};
				this.clearCustomerSearch = true;
				this.$emit("placeOrder",orderToPlace);
			}
		},
		// clearMessageAlerts(){
		// 	this.showErrorMessage = false;
		// 	this.errorMessage = null;
		//
		// 	this.showSuccessMessage = false;
		// 	this.successMessage = null;
		//
		// 	this.$emit("saleRepCustomerManagementModalOkClicked", true);
		// },
	},
	mounted: function () {
        //this.getOrderTypes();
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				var self = this;
				//this.clearCustomerSearch = false;
				if (this.showModal) {
					setTimeout(function (){
						self.clearCustomerSearch = false;
					}, 500);
					//$("#" + this.modalId).modal("show");
					$("#" + this.modalId).modal({
						keyboard: false,
						backdrop: 'static',
						show: true
					});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		// canViewCollectionOrders:{
		// 	handler: function () {
		// 		this.getOrderTypes();
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		// canViewDeliveryOrders: {
		// 	handler: function () {
		// 		this.getOrderTypes();
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		currentOrderTypeId:{
			handler: function () {
				this.orderTypeId.value = this.currentOrderTypeId;
			},
			immediate: true,
			deep: true
		}
	}
};
